import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var SwapBorrowRateMode = createPlugin({
    protocol: 'AAVE',
    type: 'ACTION',
    method: 'swapBorrowRateMode',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }) }),
                    rateMode: new FctValue({
                        options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }],
                    }),
                },
            },
            output: {},
        });
    },
});
